import React from 'react';
import { IconButton, CircularProgress, Badge } from '@mui/material';
import { withStyles } from 'tss-react/mui';

const styles = (theme) => ({
    buttonProgress: {
        color: theme.palette.primary,
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
});

const CircleProgressIconButtonBadge = withStyles(Badge, (theme) => ({
    badge: {
        fontSize: '0.65rem',
        right: 6,
        backgroundColor: theme.palette.warning.main,
        right: 10,
        top: 10,
        transform: 'scale(0.5)',
        pointerEvents: 'none'
    }
}));

class CircleProgressIconButton extends React.Component {
    state = {
        loading: false
    }

    render() {
        const { classes, className, loading, progressSize, disabled, badge, ...other } = this.props;

        return (
            <CircleProgressIconButtonBadge invisible={!badge}>
                <IconButton
                    className={className}
                    disabled={disabled ? disabled : loading}
                    {...other}
                    size="large"
                >
                    {this.props.children}
                    {loading && <CircularProgress size={progressSize ? progressSize : 24} className={classes.buttonProgress} />}
                </IconButton>
            </CircleProgressIconButtonBadge>
        );
    }
}
export default withStyles(CircleProgressIconButton, styles);